export default {
  props: {
    signup: {
      type: Object,
      required: true,
    },
  },
  emits: ['open-menu'],
}
